import PropTypes from 'prop-types';
import { AdvertiserDisclosure } from '@nerdwallet/currency';
import {
  boolCheckboxSpec,
  stringSelectSpec,
  wrapper,
} from '../../lib/editing-configs';
import UniversalContainer from '../universal-container/universal-container';

function AdvertiserDisclosureWrapper(props) {
  const { advertiserDisclosure, ...rest } = props;
  const container = advertiserDisclosure?.container || rest.container;
  const onBackground = advertiserDisclosure?.onBackground || rest.onBackground;
  const type = advertiserDisclosure?.type || rest.type;

  return (
    <UniversalContainer {...container}>
      <AdvertiserDisclosure onBackground={onBackground} type={type} />
    </UniversalContainer>
  );
}

AdvertiserDisclosureWrapper.getEditingConfig = (
  componentDocument,
  fieldName = 'advertiserDisclosure'
) => [
  wrapper([
    boolCheckboxSpec(
      `${fieldName}.onBackground`,
      'On a colorful/dark background?'
    ),
    stringSelectSpec(`${fieldName}.type`, 'Type', [
      {
        label: 'Credit cards',
        value: 'credit_cards',
      },
      {
        label: 'Investing',
        value: 'investing',
      },
    ]),
    ...UniversalContainer.getEditingConfig(
      componentDocument,
      'Container',
      [
        'backgroundColor',
        'backgroundImage',
        'border',
        'margin',
        'padding',
        'hide',
      ],
      `${fieldName}.container`
    ),
  ]),
];

AdvertiserDisclosureWrapper.displayName = 'Advertiser disclosure';

AdvertiserDisclosureWrapper.propTypes = {
  advertiserDisclosure: PropTypes.object,
  onBackground: PropTypes.bool,
};

export default AdvertiserDisclosureWrapper;
